import { ErrorFault } from "models/ErrorFault";

export const ErrorToast = (toast:ErrorFault) => {
    let bgColor;

    switch(toast.type.toLocaleLowerCase()){
        case("alert"):
        default:
        bgColor = "text-danger";
        break;
        case("success"):
        bgColor = "text-success";
    }
    return (
        <div className={"toast show"} role="alert" aria-live="assertive" aria-atomic="true">
            <div className="toast-header">
                <i className={"bi-square-fill me-2 " + bgColor}></i>
                <strong className="me-auto">{toast.title}</strong>
                <button type="button" className="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
            </div>
            <div className="toast-body">
                <p className="mb-0">{toast.message}</p>
                <p className="mb-0">Vennligst oppdater siden og prøv igjen. Hvis problemet vedvarer, kontakt <a href="https://kundeservice.1881.no" target="_blank">kundeservice</a></p>
            </div>
        </div>
    );
}